import React, { Component } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Toast } from "components";
import { addBodyClass } from "egov-ui-kit/utils/commons";
import { fetchCurrentLocation, fetchLocalizationLabel, toggleSnackbarAndSetText, setRoute } from "egov-ui-kit/redux/app/actions";
import { fetchMDMSData } from "egov-ui-kit/redux/common/actions";
import Router from "./Router";
import commonConfig from "config/common";
// import logoMseva from "egov-ui-kit/assets/images/logo-white.png";
import routes from "./Routes";
import { getLocale , setDefaultLocale, getDefaultLocale,localStorageSet, localStorageGet} from "egov-ui-kit/utils/localStorageUtils";
import isEmpty from "lodash/isEmpty";
import { LoadingIndicator, CommonShareContainer } from "components";
import { logout } from "egov-ui-kit/redux/auth/actions";
class App extends Component {
  constructor(props) {
    super(props);
    const { pathname: currentPath } = props.location;

    props.history.listen((location, action) => {
      const { pathname: nextPath } = location;
      addBodyClass(nextPath);
      props.toggleSnackbarAndSetText(false, { labelName: "", labelKey: "" }, "success");
    });

    addBodyClass(currentPath);
  }

  componentDidMount() {
    const { fetchLocalizationLabel, fetchCurrentLocation, fetchMDMSData } = this.props;
    let requestBody = {
      MdmsCriteria: {
        tenantId: commonConfig.tenantId,
        moduleDetails: [
          {
            moduleName: "common-masters",
            masterDetails: [
              {
                name: "Department",
              },
              {
                name: "Designation",
              },
              {
                name: "StateInfo",
              },
              {
                name: "ReportDay",
              },
            ],
          },
          {
            moduleName: "tenant",
            masterDetails: [
              {
                name: "tenants",
              },
              {
                name: "citymodule",
              },
            ],
          },
        ],
      },
    };
    // can be combined into one mdms call
    setDefaultLocale(getDefaultLocale());
    const { pathname } = window.location;
    if(pathname.includes("/user/otp") || pathname.includes("/user/login") || pathname.includes("/user/register")|| pathname.includes("/language-selection")|| pathname.includes("/forgot-password")  )
    fetchLocalizationLabel(getLocale() || "en_IN");

    // current location
    fetchCurrentLocation();
    fetchMDMSData(requestBody);
  }

  componentWillReceiveProps(nextProps) {
    const { route: nextRoute, authenticated, location } = nextProps;
    const { route: currentRoute, history, setRoute } = this.props;

    if (nextRoute && currentRoute !== nextRoute) {
      history.push(nextRoute);
      setRoute("");
    }

    const isPrivacyPolicy = location && location.pathname && location.pathname.includes("privacy-policy");

    if (nextProps.hasLocalisation !== this.props.hasLocalisation && !authenticated && !isPrivacyPolicy) {
      if(nextProps.hasLocalisation){
        if(getDefaultLocale()== "null")
          this.props.history.replace("/language-selection");
      }
    }
    window.addEventListener('click', (event) => {      
      console.log("click")
      const lastLoginTime = new Date().getTime();
      const lastlogintime = localStorageGet("last-login-time");
      const LoginDifferent = lastLoginTime - lastlogintime
      const deviceinfo = JSON.parse(window.localStorage.getItem("deviceinfo"))// getdeviceinfo("deviceinfo");
      let LogoutTime = 20
      if(deviceinfo)
      {
        if(deviceinfo.logoutTime !== undefined )
        {
          LogoutTime = deviceinfo.logoutTime
          //LogoutTime = 5
        }

      }
      if (LoginDifferent >= ((900000 / 15) * LogoutTime)) {
        console.log("logout action")
       // alert("1")
        // console.log(lastLoginTime)
        // console.log(LoginDifferent)
        //this.props.toggleSnackbarAndSetText(true, { labelName: "", labelKey: "CS_COMMON_INACTIVE_ACTION_LOGOUT_MESSAGE" }, "warning");        
        //logout()
      }
      else {
        console.log("action Continue")
        localStorageSet("last-login-time", new Date().getTime());
      }
    });
  }

  render() {
    const { toast, loading, defaultUrl, hasLocalisation } = this.props;
    return (
      <div>
        <Router routes={routes} hasLocalisation={hasLocalisation} defaultUrl={defaultUrl} />
        {toast && toast.open && !isEmpty(toast.message) && <Toast open={toast.open} message={toast.message} variant={toast.variant} />}
        {loading && <LoadingIndicator />}
        <CommonShareContainer componentId="rainmaker-common-share" />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { route, toast } = state.app;
  const { auth } = state;
  const { authenticated } = auth || false;
  const props = {};
  const { spinner } = state.common;
  const { stateInfoById } = state.common || [];
  let hasLocalisation = false;
  let defaultUrl = process.env.REACT_APP_NAME === "Citizen" ? "/user/register" : "/user/login";
  if (stateInfoById && stateInfoById.length > 0) {
    hasLocalisation = stateInfoById[0].hasLocalisation;
    defaultUrl = stateInfoById[0].defaultUrl;
  }
  const loading = ownProps.loading || spinner;
  if (route && route.length) {
    props.route = route;
  }
  if (toast && toast.open && toast.message && !isEmpty(toast.message)) {
    props.toast = toast;
  }
  return {
    ...props,
    loading,
    hasLocalisation,
    defaultUrl,
    authenticated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchLocalizationLabel: (locale) => dispatch(fetchLocalizationLabel(locale)),
    toggleSnackbarAndSetText: (open, message, error) => dispatch(toggleSnackbarAndSetText(open, message, error)),
    fetchMDMSData: (criteria) => dispatch(fetchMDMSData(criteria)),
    fetchCurrentLocation: () => dispatch(fetchCurrentLocation()),
    setRoute: (route) => dispatch(setRoute(route)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);



// WEBPACK FOOTER //
// ./src/modules/App.js